import { render, staticRenderFns } from "./welcome-website.vue?vue&type=template&id=39ba4a00&scoped=true&"
import script from "./welcome-website.vue?vue&type=script&lang=js&"
export * from "./welcome-website.vue?vue&type=script&lang=js&"
import style0 from "./welcome-website.vue?vue&type=style&index=0&id=39ba4a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba4a00",
  null
  
)

export default component.exports